var _style, _defs, _rect, _path, _g, _g2, _rect2, _g3, _rect3, _desc, _g4, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line0, _line1, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _line28, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCityRainy(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "w-screen sm:w-full ",
    viewBox: "0 0 1200 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    /* Animaciones de loop infinito */\n    @keyframes cloudMove {\n      0% { transform: translateX(0); }\n      100% { transform: translateX(-1200px); }\n    }\n    @keyframes waveMove {\n      0% { transform: translateX(0); }\n      100% { transform: translateX(-400px); }\n    }\n    @keyframes blink {\n      0%, 100% { opacity: 1; }\n      50% { opacity: 0.3; }\n    }\n\n    .cloud { animation: cloudMove 60s linear infinite; }\n    .waves { animation: waveMove 8s linear infinite; }\n    .window { animation: blink 2s infinite; }\n    .window:nth-child(2n) { animation-delay: 0.5s; }\n    .window:nth-child(3n) { animation-delay: 1s; }\n    .window:nth-child(4n) { animation-delay: 1.5s; }\n  ")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "skyRainy",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#7fb3d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#7fb3d5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "reflection",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#7fb3d5",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#7fb3d5",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#7fb3d5",
    stopOpacity: 0.4
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 700,
    fill: "url(#skySunset)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 500 L200 380 L400 440 L600 360 L800 450 L1000 370 L1200 440 L1200 700 L0 700 Z",
    fill: "#2f3a65",
    opacity: 0.4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#2f4f4f",
    opacity: 0.6,
    transform: "translate(0,120)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 460,
    width: 20,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 450,
    width: 25,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 470,
    width: 15,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 440,
    width: 30,
    height: 50
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 455,
    width: 20,
    height: 35
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330,
    y: 450,
    width: 25,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    x: 380,
    y: 465,
    width: 15,
    height: 25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430,
    y: 445,
    width: 30,
    height: 45
  }), /*#__PURE__*/React.createElement("rect", {
    x: 480,
    y: 460,
    width: 20,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    x: 530,
    y: 450,
    width: 25,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    x: 580,
    y: 470,
    width: 15,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 630,
    y: 440,
    width: 30,
    height: 50
  }), /*#__PURE__*/React.createElement("rect", {
    x: 680,
    y: 455,
    width: 20,
    height: 35
  }), /*#__PURE__*/React.createElement("rect", {
    x: 730,
    y: 450,
    width: 25,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    x: 780,
    y: 465,
    width: 15,
    height: 25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 830,
    y: 445,
    width: 30,
    height: 45
  }), /*#__PURE__*/React.createElement("rect", {
    x: 880,
    y: 460,
    width: 20,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    x: 930,
    y: 450,
    width: 25,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    x: 980,
    y: 470,
    width: 15,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1030,
    y: 440,
    width: 30,
    height: 50
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1080,
    y: 455,
    width: 20,
    height: 35
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1130,
    y: 450,
    width: 25,
    height: 40
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffd27f",
    className: "window",
    transform: "translate(0,120)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 465,
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 455,
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 445,
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335,
    y: 455,
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 435,
    y: 450,
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 535,
    y: 455,
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 635,
    y: 450,
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 735,
    y: 455,
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 835,
    y: 450,
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 935,
    y: 455,
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1035,
    y: 450,
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1085,
    y: 460,
    width: 5,
    height: 5
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 600,
    width: 1200,
    height: 100,
    fill: "url(#reflection)",
    opacity: 0.6
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "waves"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 620 Q100 630 200 620 T400 620 T600 620 T800 620 T1000 620 T1200 620              T1400 620 T1600 620",
    fill: "none",
    stroke: "#ffffff",
    strokeOpacity: 0.3,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 640 Q150 650 300 640 T600 640 T900 640 T1200 640              T1500 640 T1800 640",
    fill: "none",
    stroke: "#ffd27f",
    strokeOpacity: 0.25,
    strokeWidth: 5
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 600,
    width: 1200,
    height: 100,
    fill: "#2f4f4f",
    opacity: 0.6
  })), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Horizonte urbano minimalista loopable") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "SVG animado de horizonte urbano con nubes, ondas y ventanas animadas en loop infinito perfecto.")), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 200,
    cy: 180,
    rx: 120,
    ry: 40,
    fill: "#cfd8dc",
    fillOpacity: 0.5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    values: "200;1250",
    dur: "60s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 600,
    cy: 220,
    rx: 140,
    ry: 45,
    fill: "#b0bec5",
    fillOpacity: 0.3
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    values: "600;-200",
    dur: "80s",
    repeatCount: "indefinite"
  })))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: -50,
    x2: 3,
    y2: 50,
    stroke: "#90a4ae",
    strokeWidth: 1.5,
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    from: "0 0",
    to: "0 800",
    dur: "1.5s",
    repeatCount: "indefinite"
  }))), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: -50,
    x2: 43,
    y2: 50,
    stroke: "#90a4ae",
    strokeWidth: 1.5,
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    from: "0 0",
    to: "0 800",
    dur: "1.8s",
    repeatCount: "indefinite"
  }))), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 80,
    y1: -50,
    x2: 83,
    y2: 50,
    stroke: "#90a4ae",
    strokeWidth: 1.5,
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    from: "0 0",
    to: "0 800",
    dur: "2.1s",
    repeatCount: "indefinite"
  }))), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 120,
    y1: -50,
    x2: 123,
    y2: 50,
    stroke: "#90a4ae",
    strokeWidth: 1.5,
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    from: "0 0",
    to: "0 800",
    dur: "2.4s",
    repeatCount: "indefinite"
  }))), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 160,
    y1: -50,
    x2: 163,
    y2: 50,
    stroke: "#90a4ae",
    strokeWidth: 1.5,
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    from: "0 0",
    to: "0 800",
    dur: "2.7s",
    repeatCount: "indefinite"
  }))), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: -50,
    x2: 203,
    y2: 50,
    stroke: "#90a4ae",
    strokeWidth: 1.5,
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    from: "0 0",
    to: "0 800",
    dur: "1.5s",
    repeatCount: "indefinite"
  }))), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 240,
    y1: -50,
    x2: 243,
    y2: 50,
    stroke: "#90a4ae",
    strokeWidth: 1.5,
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    from: "0 0",
    to: "0 800",
    dur: "1.8s",
    repeatCount: "indefinite"
  }))), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 280,
    y1: -50,
    x2: 283,
    y2: 50,
    stroke: "#90a4ae",
    strokeWidth: 1.5,
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    from: "0 0",
    to: "0 800",
    dur: "2.1s",
    repeatCount: "indefinite"
  }))), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 320,
    y1: -50,
    x2: 323,
    y2: 50,
    stroke: "#90a4ae",
    strokeWidth: 1.5,
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    from: "0 0",
    to: "0 800",
    dur: "2.4s",
    repeatCount: "indefinite"
  }))), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    x1: 360,
    y1: -50,
    x2: 363,
    y2: 50,
    stroke: "#90a4ae",
    strokeWidth: 1.5,
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    from: "0 0",
    to: "0 800",
    dur: "2.7s",
    repeatCount: "indefinite"
  }))), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    x1: 400,
    y1: -50,
    x2: 403,
    y2: 50,
    stroke: "#90a4ae",
    strokeWidth: 1.5,
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    from: "0 0",
    to: "0 800",
    dur: "1.5s",
    repeatCount: "indefinite"
  }))), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 440,
    y1: -50,
    x2: 443,
    y2: 50,
    stroke: "#90a4ae",
    strokeWidth: 1.5,
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    from: "0 0",
    to: "0 800",
    dur: "1.8s",
    repeatCount: "indefinite"
  }))), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 480,
    y1: -50,
    x2: 483,
    y2: 50,
    stroke: "#90a4ae",
    strokeWidth: 1.5,
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    from: "0 0",
    to: "0 800",
    dur: "2.1s",
    repeatCount: "indefinite"
  }))), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 520,
    y1: -50,
    x2: 523,
    y2: 50,
    stroke: "#90a4ae",
    strokeWidth: 1.5,
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    from: "0 0",
    to: "0 800",
    dur: "2.4s",
    repeatCount: "indefinite"
  }))), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 560,
    y1: -50,
    x2: 563,
    y2: 50,
    stroke: "#90a4ae",
    strokeWidth: 1.5,
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    from: "0 0",
    to: "0 800",
    dur: "2.7s",
    repeatCount: "indefinite"
  }))), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 600,
    y1: -50,
    x2: 603,
    y2: 50,
    stroke: "#90a4ae",
    strokeWidth: 1.5,
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    from: "0 0",
    to: "0 800",
    dur: "1.5s",
    repeatCount: "indefinite"
  }))), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 640,
    y1: -50,
    x2: 643,
    y2: 50,
    stroke: "#90a4ae",
    strokeWidth: 1.5,
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    from: "0 0",
    to: "0 800",
    dur: "1.8s",
    repeatCount: "indefinite"
  }))), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 680,
    y1: -50,
    x2: 683,
    y2: 50,
    stroke: "#90a4ae",
    strokeWidth: 1.5,
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    from: "0 0",
    to: "0 800",
    dur: "2.1s",
    repeatCount: "indefinite"
  }))), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 720,
    y1: -50,
    x2: 723,
    y2: 50,
    stroke: "#90a4ae",
    strokeWidth: 1.5,
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    from: "0 0",
    to: "0 800",
    dur: "2.4s",
    repeatCount: "indefinite"
  }))), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    x1: 760,
    y1: -50,
    x2: 763,
    y2: 50,
    stroke: "#90a4ae",
    strokeWidth: 1.5,
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    from: "0 0",
    to: "0 800",
    dur: "2.7s",
    repeatCount: "indefinite"
  }))), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    x1: 800,
    y1: -50,
    x2: 803,
    y2: 50,
    stroke: "#90a4ae",
    strokeWidth: 1.5,
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    from: "0 0",
    to: "0 800",
    dur: "1.5s",
    repeatCount: "indefinite"
  }))), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    x1: 840,
    y1: -50,
    x2: 843,
    y2: 50,
    stroke: "#90a4ae",
    strokeWidth: 1.5,
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    from: "0 0",
    to: "0 800",
    dur: "1.8s",
    repeatCount: "indefinite"
  }))), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    x1: 880,
    y1: -50,
    x2: 883,
    y2: 50,
    stroke: "#90a4ae",
    strokeWidth: 1.5,
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    from: "0 0",
    to: "0 800",
    dur: "2.1s",
    repeatCount: "indefinite"
  }))), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    x1: 920,
    y1: -50,
    x2: 923,
    y2: 50,
    stroke: "#90a4ae",
    strokeWidth: 1.5,
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    from: "0 0",
    to: "0 800",
    dur: "2.4s",
    repeatCount: "indefinite"
  }))), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    x1: 960,
    y1: -50,
    x2: 963,
    y2: 50,
    stroke: "#90a4ae",
    strokeWidth: 1.5,
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    from: "0 0",
    to: "0 800",
    dur: "2.7s",
    repeatCount: "indefinite"
  }))), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    x1: 1000,
    y1: -50,
    x2: 1003,
    y2: 50,
    stroke: "#90a4ae",
    strokeWidth: 1.5,
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    from: "0 0",
    to: "0 800",
    dur: "1.5s",
    repeatCount: "indefinite"
  }))), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    x1: 1040,
    y1: -50,
    x2: 1043,
    y2: 50,
    stroke: "#90a4ae",
    strokeWidth: 1.5,
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    from: "0 0",
    to: "0 800",
    dur: "1.8s",
    repeatCount: "indefinite"
  }))), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    x1: 1080,
    y1: -50,
    x2: 1083,
    y2: 50,
    stroke: "#90a4ae",
    strokeWidth: 1.5,
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    from: "0 0",
    to: "0 800",
    dur: "2.1s",
    repeatCount: "indefinite"
  }))), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    x1: 1120,
    y1: -50,
    x2: 1123,
    y2: 50,
    stroke: "#90a4ae",
    strokeWidth: 1.5,
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    from: "0 0",
    to: "0 800",
    dur: "2.4s",
    repeatCount: "indefinite"
  }))), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    x1: 1160,
    y1: -50,
    x2: 1163,
    y2: 50,
    stroke: "#90a4ae",
    strokeWidth: 1.5,
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    from: "0 0",
    to: "0 800",
    dur: "2.7s",
    repeatCount: "indefinite"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 600,
    r: 0,
    stroke: "#a3c9e2",
    strokeWidth: 1,
    fill: "none",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "0;25",
    dur: "3s",
    begin: "0s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.6;0;0",
    dur: "3s",
    begin: "0s",
    repeatCount: "indefinite"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 600,
    r: 0,
    stroke: "#a3c9e2",
    strokeWidth: 1,
    fill: "none",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "0;25",
    dur: "3s",
    begin: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.6;0;0",
    dur: "3s",
    begin: "1s",
    repeatCount: "indefinite"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 600,
    r: 0,
    stroke: "#a3c9e2",
    strokeWidth: 1,
    fill: "none",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "0;25",
    dur: "3s",
    begin: "2s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.6;0;0",
    dur: "3s",
    begin: "2s",
    repeatCount: "indefinite"
  }))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 550,
    cy: 600,
    r: 0,
    stroke: "#a3c9e2",
    strokeWidth: 1,
    fill: "none",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "0;25",
    dur: "3s",
    begin: "3s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.6;0;0",
    dur: "3s",
    begin: "3s",
    repeatCount: "indefinite"
  }))), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 700,
    cy: 600,
    r: 0,
    stroke: "#a3c9e2",
    strokeWidth: 1,
    fill: "none",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "0;25",
    dur: "3s",
    begin: "4s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.6;0;0",
    dur: "3s",
    begin: "4s",
    repeatCount: "indefinite"
  }))), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 850,
    cy: 600,
    r: 0,
    stroke: "#a3c9e2",
    strokeWidth: 1,
    fill: "none",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "0;25",
    dur: "3s",
    begin: "5s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.6;0;0",
    dur: "3s",
    begin: "5s",
    repeatCount: "indefinite"
  }))), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 1000,
    cy: 600,
    r: 0,
    stroke: "#a3c9e2",
    strokeWidth: 1,
    fill: "none",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "0;25",
    dur: "3s",
    begin: "6s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.6;0;0",
    dur: "3s",
    begin: "6s",
    repeatCount: "indefinite"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCityRainy);
export default __webpack_public_path__ + "static/media/city-rainy.c1e687dd4644995598426e3af29d6e16.svg";
export { ForwardRef as ReactComponent };